<template>
  <div id="app">
    <div class="center">
      <div class="header">
        <div class="header-title">
          <div class="header-text" v-if="headerText">{{ headerText }}</div>
          <div class="set">
            <el-dropdown trigger="click">
              <img src="../assets/images/public/setting.png" />
              <el-dropdown-menu slot="dropdown"  class="setdropdown">
                <el-dropdown-item @click.native="userCenterJump">管理后台</el-dropdown-item>
                <el-dropdown-item @click.native="logoutSystem">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="user">{{ userInfo.nickname || '未知用户' }} {{ userInfo.mobile }}</div>
        </div>
        <div class="nav" v-show="showMeau && meauList.length>0">
          <a 
            v-for="(item,index) in meauList"
            :key="index"
            href="javascript:void(0)" 
            :class="index === 0?item.url === pageActive?'active index':'index':item.url === pageActive?'active':''" 
            @click="jumpPage(item.url)">{{ item.name }}</a>
          <!-- <a href="javascript:void(0)" :class="pageActive === 1?'active index':'index'" @click="jumpPage(1)">首页</a>
          <a href="javascript:void(0)" :class="pageActive === 2?'active':''"  @click="jumpPage(2)">智慧牧场</a>
          <a href="javascript:void(0)" :class="pageActive === 3?'active':''"  @click="jumpPage(3)">牛只管控</a>
          <a href="javascript:void(0)" :class="pageActive === 4?'active':''"  @click="jumpPage(4)">中央厨房</a>
          <a href="javascript:void(0)" :class="pageActive === 5?'active':''"  @click="jumpPage(5)">养母繁犊</a>
          <a href="javascript:void(0)" :class="pageActive === 6?'active':''"  @click="jumpPage(6)">屠宰加工</a>
          <a href="javascript:void(0)" :class="pageActive === 7?'active':''"  @click="jumpPage(7)">销售溯源</a>
          <a href="javascript:void(0)" :class="pageActive === 8?'active':''"  @click="jumpPage(8)">设备管理</a> -->
        </div>
      </div>
      <router-view v-if='isShow'></router-view>
    </div>
  </div>
</template>

<script>
import { 
  publicIndexNav,
  publicHeaderText
} from "@/apis/home";

export default {
  name: 'App',
  data() {
    return {
      pageActive:1,
      isShow:true,
      showNav:window.location.pathname,
      urlObj:{
        '/index':1,
        '/ranch':2,
        '/manage':3,
        '/kitchen':4,
        '/calf':5,
        '/slaughter':6,
        '/trace':7,
        '/device':8,
      },
      fanUrlObj:{
        1:'/index',
        2:'/ranch',
        3:'/manage',
        4:'/kitchen',
        5:'/calf',
        6:'/slaughter',
        7:'/trace',
        8:'/device',
      },
      showMeau:true,
      meauList:[],
      headerText:'',
      userInfo:{}
    };
  },
  mounted(){
    this.getNav()
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.showNav = window.location.pathname
    this.pageActive = this.urlObj[this.showNav]
    document.addEventListener('keydown', function (event) {
      if ((event.ctrlKey === true || event.metaKey === true)
        && (event.which === 61 || event.which === 107
          || event.which === 173 || event.which === 109
          || event.which === 187 || event.which === 189)) {
        event.preventDefault();
      }
    }, false);
    // Chrome IE 360
    window.addEventListener('mousewheel', function (event) {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    }, { passive: false });

    //firefox
    window.addEventListener('DOMMouseScroll', function (event) {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    }, { passive: false });
  },
  watch:{
    $route: {
      handler: function(to) {
        this.isShow = false;
        this.showNav = to.path
        this.pageActive = this.urlObj[this.showNav]
        this.$nextTick(() => {
          this.isShow = true;
          this.subpagesNotshow()
        });
      },
      immediate: true
    },
  },
  created(){
  },
  methods:{
    getNav(){
      publicHeaderText().then(res=>{
        this.headerText = res.data.title
      }),
      publicIndexNav().then(res=>{
        res.data.forEach(x=>{
          x.url = parseInt(x.url)
        })
        this.meauList = res.data
      })
    },
    jumpPage(val){
      this.pageActive = val
      this.$router.push({ path: this.fanUrlObj[val] })
    },
    logoutSystem(){
      this.$confirm('确定要退出登录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('uid')
        localStorage.removeItem('token')
        window.location.replace(`/login`)
      })
    },
    userCenterJump(){
      window.open('http://yn.saas-rnyzpt.com/mXtcSMxHaU.php/index/login')
    },
    subpagesNotshow(){
      if(this.showNav==='/detail' || this.showNav==='/index/news'|| this.showNav==='/manage/list'|| this.showNav==='/manage/detail' || this.showNav==='/calf/detail' ||this.showNav==='/trace/detail'||this.showNav==='/trace/list'||this.showNav==='/calf/list'){
        this.showMeau = false
      }else{
        this.showMeau = true
      }
    }
  }
}
</script>
<style lang="scss">
.header{
  background: url("../assets/images/public/line.png") no-repeat center 76px;
  background-size:1900px 5px;
}
.public-footer{
  overflow: hidden;
  padding: 0 18px;
  .jishu{
    float: right;
    color: #fff;
    line-height: 35px;
    font-size: 16px;
  }
  .fenge{
    float: left;
    padding: 0 26px 0;
    font-size: 16px;
    letter-spacing: 2px;
    line-height: 35px;
    color: #06B0FF ;
  }
  .tq,.time{
    float: left;
    color: #fff;
    line-height: 35px;
    font-size: 16px;

  }
  .tq{
    padding-left: 53px;
    background-image: url('../assets/images/public/dyun.png');
    background-size: 38px 32px;
    background-position: left center;
    background-repeat: no-repeat;
  }
}
.header-title{
  display: block;
  height: 93px;
  padding: 0;
  .header-text{
    display: block;
    font-weight: bold;
    font-size: 28px;
    float: left;
    line-height: 63px;
    padding: 0 50px 0 18px;
    color: #06B0FF;
    background: url("../assets/images/public/header.png") no-repeat left 0;
    background-size: 100% 63px;
  }
  .user,.set{
    float: right;
  }
  .set{
    margin-right: 23px;
    img{
      cursor: pointer;
      width: 40px;
      height: 40px;
      margin-top: 22px;
    }
  }
  .user{
    margin-top: 20px;
    margin-right: 25px;
    line-height: 44px;
    font-size: 16px;
    color: #fff;
    padding-left: 62px;
    width: 188px;
    background: url('../assets/images/public/user.png') no-repeat 0 0;
    background-size: 250px 44px;
  }
}
.center{
  width: 1920px;
  margin: 0 auto;
}
.nav{
  overflow: hidden;
  padding-bottom: 10px;
  margin-left: 15px;
  a{
    float: left;
    width: 162px;
    color: #fff;
    line-height: 41px;
    font-size: 20px;
    text-align: center;
    margin-right: -13px;
    height: 41px;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-image: url("../assets/images/public/nav2.png");
    background-size: 162px 41px;
  }
  a.index{
    background-image: url("../assets/images/public/nav1.png");
  }
  a.active{
    background-image: url("../assets/images/public/nav22.png");
  }
  a.active.index{
    background-image: url("../assets/images/public/nav12.png");
  }
}
.nav.hide{
  display: none;
}
.fl{
  float: left;
}
.fr{
  float: right;
}
#app{
  min-height: 100vh;
  background-color: #0F254B;
  background-image: url('../assets/images/public/bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  // min-width: 1920px;
  width: 100%;
  overflow: hidden;

}
.page-content{
  margin: 10px 0px 0 15px;
  overflow: hidden;
}
.page-box{
  position: relative;
  margin-bottom: 15px;
  background: linear-gradient(to bottom, rgba(78, 124, 168, 0.5), rgba(38, 70, 111, 0));
  .box-header{
    background: url('../assets/images/public/left.png') no-repeat 0 0;
    background-size: 36px 26px;
    display: block;
    height: 36px;
    span{
      float: left;
      color: #fff;
      font-size: 16px;
      line-height: 36px;
      margin-left: 52px;
    }
    label{
      float: right;
      margin-right: 16px;
      line-height: 36px;
      font-size: 14px;
      color: #D7E7FE;
    }
  }
  .box-header.noheader{
    background: url('../assets/images/pages/icon/zuoshang.png') no-repeat 0 0;
  }
  .box-header.newheader{
    height: 10px;
    background: url('../assets/images/pages/icon/zuoshang.png') no-repeat 0 0;
  }
  .box-box{
    position: absolute;
    z-index: 1;
    top: 38px;
    left: 0;
    right: 4px;
    bottom: 10px;
    background-image: url('../assets/images/public/dian.png'), url('../assets/images/public/dian.png');
    background-position: left 5px bottom 5px, right 5px top 5px ;
    background-repeat: no-repeat,no-repeat;
    border-left: 2px solid rgba(215, 231, 254, 0.3);
    border-right:  2px solid rgba(215, 231, 254, 0.3);
    i{
      position: absolute;
      width: 2px;
      height: 2px;
      background-color: #fff;
      z-index: 2;
    }
    .dian1{ left: -2px; top: -3px;}
    .dian2{ right: -2px; top: -3px;}
    .dian3{ left: -2px; bottom: -3px;}
    .dian4{ right: -2px; bottom: -3px;}
    .box-content{
      position: absolute;
      z-index: 2;
      top: -2px;
      bottom: -2px;
      left: 15px;
      right: 15px;
      border-top: 2px solid rgba(215, 231, 254, 0.3);
      border-bottom:  2px solid rgba(215, 231, 254, 0.3);
      strong{
        position: absolute;
        width: 3px;
        height: 3px;
        background-color: #fff;
        z-index: 3;
      }
      .rect1{left:-4px;top: -2px;}
      .rect2{right:-4px;top: -2px;}
      .rect3{left:-4px;bottom: -2px;}
      .rect4{right:-4px;bottom: -2px;}
    }
  }
  .box-box.noheader{
    top: 31px;
  }
  .box-box.newheader{
    top: 40px;
    .box-content{
      top: -28px;
    }
  }
}
.sub-nav{
  float: left;
  padding: 4px 0;
  width: 94px;
  height: 877px;
  background-color: rgba(38,70,111,0.4);
  .sub-list{
    height: 50%;
    overflow: hidden;
    cursor: pointer;
    img{
      display: block;
      padding: 195px 35px 0;
      width: 24px;
    }
    span{
      display: block;
      padding-top: 12px;
      text-align: center;
      font-size: 14px;
      color: #06B0FF;
    }
  }
  .sub-list.on{
    background: url('../assets/images/pages/ranch/on.png') no-repeat center 0;
    background-size: 86px 432px;
    span{
      color: #fff;
      padding-left: 10px;
    }
  }
}
.table-box{
  overflow: hidden;
}
</style>
<style>
.setdropdown{
  background: rgba(38, 70, 111, 0.5) !important;
  padding: 0;
  margin: 2px !important;
  width: 150px;
}
.setdropdown .el-dropdown-menu__item{
  color: #fff;
}
.setdropdown .popper__arrow{
  display: none !important;
}
 .table-box .el-table tr.even-row {
  background-color: rgba(38, 70, 111, 0);
}
.table-box  .el-table tr.odd-row {
  background-color: rgba(6, 176, 255, 0.5);
}
.table-box .el-table__header-wrapper tr,.table-box .el-table th.el-table__cell.is-leaf {
  background-color: rgba(6, 176, 255, 0.3);
}
.table-box .el-table td.el-table__cell,.table-box  .el-table th.el-table__cell.is-leaf{
  border-bottom: 0 !important;
  padding: 7px 0 7px 10px;
}
.table-box .el-table th.el-table__cell>.cell{
  font-size: 14px;
  padding: 0 5px;
  color: #06B0FF;
}
.table-box .el-table .el-table__cell{
  padding: 5px 0;
  color: #D7E7FE;
}
.table-box .el-table::before,.table-box .el-table__fixed-right::before,.table-box .el-table__fixed::before {
  height: 0px;
}
.table-box .el-table__body tr:hover > td {
  background-color:rgba(6, 176, 255, 0.1) !important;
}
.table-box .el-table .cell{
  padding-left: 5px;
  padding-right: 5px;
  line-height: 23px;
}
.table-box .el-table .cell{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table-box .el-table .cell .el-button{
  padding: 0;
  font-size: 12px;
}
.el-table .el-table__cell.gutter{
  background-color: rgba(6, 176, 255, 0.3);
}
.table-box .el-table__body tr.current-row>td{
  background-color: #06B0FF !important;
}
::-webkit-scrollbar,
::-webkit-scrollbar-track{
  background-color: transparent;
}
::-webkit-scrollbar {
    width: 6px; /* 水平滚动条的高度 */
    height: 6px; /* 垂直滚动条的宽度 */
}
 
/* 设置滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
    border-radius: 6px; /* 滑块的圆角 */
}
 
/* 设置滚动条轨道的样式 */
::-webkit-scrollbar-track {
    border-radius: 6px; /* 轨道的圆角 */
}
/* 设置滚动条的滑块透明度 */
::-webkit-scrollbar-thumb {
  width: 6px;
  border-radius: 3px;
  background-color: rgba(215, 231, 254, 0.3); /* 50% 透明度的黑色滑块 */
}
 
/* 设置滚动条的滑块hover效果透明度 */
::-webkit-scrollbar-thumb:hover {
  background-color: rgba(215, 231, 254, 0.5); /* 50% 透明度的黑色滑块 */
}
.select-crow{
  background: none;
  float: left;
  margin-left: 17px;
  height: 33px;
  margin-top: 15px;
  line-height: 33px;
}
.select-crow .el-input__inner{
  background: none;
  height: 33px;
  line-height: 33px;
  border: 0;
  color: #fff;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 16px;
  font-weight: 500;
  background: url('../assets/images/pages/down.png') repeat-x;
  color: #fff;
  border-radius: 0;
}
.select-crow  .el-input--suffix .el-input__inner{
  padding-right: 15px;
}
.select-crow .el-input .el-select__caret{
  display: none;
}
.box-header .input-with-select{
  float: right;
  width: 260px;
  line-height: 34px;
  margin: 4px 20px 0 0;
}
.box-header .input-with-select .el-input__inner{
  height: 28px;
  line-height: 28px;
  padding: 0 10px;
  font-size: 14px;
}
.box-header .input-with-select .el-input-group__append{
  padding: 0 10px;
  height: 28px;
  line-height: 28px !important;
  border: 0;
}
</style>